@use "variables" as *;

.listItem {
  font-weight: bold;
}

.normalText {
  font-weight: normal;
  white-space: pre-wrap;
}

.templateButton {
  margin: $spacing-l 0;
}
